export namespace TitleUtils {
  export function create(prefix?: string): string {
    return (prefix ? prefix + ' - ' : '') + 'Atelier Beau / Voir';
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/TitleUtils.ts